import React from 'react'
import MulAboutUs from '../../mulecules/about-us/mul-about-us'

function OrgAboutUs() {
    return (
        <div>
            <MulAboutUs/>
        </div>
    )
}

export default OrgAboutUs
